/** @format */

import React, { useState } from 'react';
import '../../css/cards/Membership.css';

import { AiFillQuestionCircle } from 'react-icons/ai';
import { IoCheckmarkCircle } from 'react-icons/io5';
import { CgDanger } from 'react-icons/cg';
import { useDispatch } from 'react-redux';

import { openTrainingMore } from '../../features/training';
import SupportInitiative from '../SupportInitiative';
import SimpleModal from '../modals/SimpleModal';
import SimpleModal2 from '../modals/SimpleModal2';

const Membership = ({ membership, country }) => {
	const dispatch = useDispatch();
	const [modal, setModal] = useState(false);

	const closeModal2 = () => setModal(false);

	const [url, setUrl] = useState('');
	const [close, setClose] = useState(true);
	const [close2, setClose2] = useState(true);

	const closeModal = () => setModal(false);

	const handlerClose = (url) => {
		setUrl(url);
		close ? setClose(false) : setClose(true);
	};

	const handlerClose2 = () => {
		close2 ? setClose2(false) : setClose2(true);
	};

	const handleCloseModal = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	const handleCloseModal2 = (event) => {
		if (event.target.className === 'Inscriptions ') {
			setClose(true);
		}
	};

	return (
		<div className='Membership'>
			<SimpleModal
				close={close}
				handlerClose={handlerClose}
				handleCloseModal={handleCloseModal}
				url={url}
			/>
			<SimpleModal2
				close={close2}
				handlerClose={handlerClose2}
				handleCloseModal={handleCloseModal2}
			/>

			<div className='membership-franja-container'>
				<div className='membership-franja'>
					<h3>{membership?.off}</h3>
				</div>
			</div>

			<div className='membership-header'>
				<img src={membership.image} alt='Header Membership' />
			</div>
			<div className='membership-body'>
				<div className='membership-info'>
					<div className='membership-icon'>
						<img src={membership.icon} alt='Membership Icon' />
					</div>
					<div className='membership-name'>
						<h4
							style={membership.title === 'Full Plan' ? { color: '#6000de' } : { color: '#000000' }}
						>
							{membership.title}
							{membership.description && (
								<AiFillQuestionCircle
									style={{
										fontSize: 18,
										marginLeft: '1ch',
										cursor: 'pointer',
									}}
									onClick={() => {
										dispatch(
											openTrainingMore({
												modal: true,
												title: membership.title,
												more: membership.description,
											})
										);
									}}
								/>
							)}
						</h4>
						<h5>
							{membership.pagos} <br />
							{membership.priceUSD}
							<br />
							<sup>${membership.price_before.ALL}</sup>
						</h5>

						<CgDanger className='membership-icon-danger' onClick={() => handlerClose2()} />
					</div>
				</div>

				<ul className='membership-card-items'>
					{/* <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
						<select className='price-select' name='price' id='price'>
							<option hidden={true} value=''>
								Ver precios por país
							</option>
							{membership.prices.map((e, i) => (
								<option key={i} value={e.price}>
									{e.price}
								</option>
							))}
						</select>
						<AiFillQuestionCircle
							className='description-question'
							onClick={() => {
								setModal(true);
							}}
						/>
					</div> */}
					{membership.items.map((e, i) => (
						<li
							key={i}
							style={
								e.item === 'Acceso adicional al campamento.'
									? { fontWeight: 700 }
									: { fontWeight: 300 }
							}
						>
							<IoCheckmarkCircle style={{ fontSize: 20, marginRight: 20 }} />
							{e.item}
							{e.more ? (
								<AiFillQuestionCircle
									className='question-icon'
									onClick={() => {
										dispatch(
											openTrainingMore({
												modal: true,
												title: e.item,
												more: e.more,
											})
										);
									}}
								/>
							) : null}
						</li>
					))}
				</ul>
				<div className='membership-button'>
					<a
						onClick={() => handlerClose(membership.urls[0])}
						// target={'_blank'}
						rel='noreferrer'
						className='paypal'
					>
						{membership.urls[0].name}
					</a>
					<a
						onClick={() => handlerClose(membership.urls[1])}
						// target={'_blank'}
						rel='noreferrer'
						className='card'
					>
						{membership.urls[1].name}
					</a>
				</div>
			</div>
			<SupportInitiative modal={modal} closeModal={closeModal2} />
		</div>
	);
};

export default Membership;
